import { frontConstants } from "../constants/frontConstants";

const initialState = {
  sending: false,
  dealList: {},
  menuList: {},
  topDeal: {},
  curDeal: {},
  merDirectory: {},
  upcomingDeal: {},
  detail: {},
  cartStatus: {},
  UpdatecartStatus: {},
  cartDetail: {},
  cartError: {},
  error: null,
  errorSubscriber: null,
  checkoutStatus: {},
  regStatus: {},
  logoutStatus: {},
  voucherList: {},
  voucherListArchive: {},
  orderList: {},
  custDetail: {},
  profileStatus: {},
  passwordStatus: {},
  voucherDetail: {},
  creditAmount: {},
  promoStatus: {},
  promoError: {},
  couponStatus: {},
  attribute: {},
  subscribeStatus: {},
  userdealResponse: {},
  paying: false,
  cityList: {},
  widgetImage: {},
  partnerStatus: {},
  becomePermission: {},
  ordertracking: {},
  getCharity: {},
  promoRemoveStatus: {},
  couponList: {},
  refferals: {},
  card: {},
  allCityList: {},
  langList: {},
  mailedList: {},
  giftList: {},
  giftOrderList: {},
  generatedList: {},
  subscriberDetail: {},
  taxRate: {},
  SearchStateList: {},
  GuestEmail: {},
  UserKeyStatus: {},
  UserKeyError: {},
  StatusGuestEmail: {},
};

export default function frontReducer(state = initialState, action) {
  switch (action.type) {
    case frontConstants.GET_ALLDEAL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_ALLDEAL_SUCCESS:
      return {
        ...state,
        sending: false,
        dealList: action.data,
      };
    case frontConstants.GET_ALLDEAL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_MENU_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_MENU_SUCCESS:
      return {
        ...state,
        sending: false,
        menuList: action.data,
      };
    case frontConstants.GET_MENU_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_TOPDEAL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_TOPDEAL_SUCCESS:
      return {
        ...state,
        sending: false,
        topDeal: action.data,
      };
    case frontConstants.GET_TOPDEAL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_CURRENTDEAL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_CURRENTDEAL_SUCCESS:
      return {
        ...state,
        sending: true,
        curDeal: action.data.data,
        currentCityID: action,
      };
    case frontConstants.GET_CURRENTDEAL_FAILURE:
      return {
        ...state,
        ssending: false,
        error: action.error,
      };
    case frontConstants.GET_MERCHANTDIRECTORYLIST_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_MERCHANTDIRECTORYLIST_SUCCESS:
      return {
        ...state,
        sending: true,
        merDirectory: action.data.data,
        currentCityID: action,
      };
    case frontConstants.GET_MERCHANTDIRECTORYLIST_FAILURE:
      return {
        ...state,
        ssending: false,
        error: action.error,
      };
    case frontConstants.GET_UPCOMINGDEAL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_UPCOMINGDEAL_SUCCESS:
      return {
        ...state,
        sending: false,
        upcomingDeal: action.data,
      };
    case frontConstants.GET_UPCOMINGDEAL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_DEALDETAIL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_DEALDETAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        detail: action.data,
      };
    case frontConstants.GET_DEALDETAIL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_ADDTOCART_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_ADDTOCART_SUCCESS:
      return {
        ...state,
        sending: false,
        cartStatus: action.data,
      };
    case frontConstants.GET_ADDTOCART_FAILURE:
      return {
        ...state,
        sending: false,
        cartError: action.error,
      };
    case frontConstants.GET_CHECKUSERKEY_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_CHECKUSERKEY_SUCCESS:
      return {
        ...state,
        sending: false,
        UserKeyStatus: action.data,
      };
    case frontConstants.GET_CHECKUSERKEY_FAILURE:
      return {
        ...state,
        sending: false,
        UserKeyError: action.error,
      };
    case frontConstants.GET_CARTDETAIL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_CARTDETAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        cartDetail: action,
      };
    case frontConstants.GET_CARTDETAIL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };

    case frontConstants.GET_CARTQUANTITY_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_CARTQUANTITY_SUCCESS:
      return {
        ...state,
        sending: false,
        cartQuantity: action,
      };
    case frontConstants.GET_CARTQUANTITY_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };

    case frontConstants.GET_CARTUPDATE_REQUEST:
      return {
        ...state,
        paying: false,
        sending: true,
      };
    case frontConstants.GET_CARTUPDATE_SUCCESS:
      return {
        ...state,
        paying: false,
        sending: false,
        UpdatecartStatus: action.data,
      };
    case frontConstants.GET_CARTUPDATE_FAILURE:
      return {
        ...state,
        sending: false,
        cartError: action.error,
      };
    case frontConstants.GET_REMOVEITEM_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_REMOVEITEM_SUCCESS:
      return {
        ...state,
        sending: false,
        UpdatecartStatus: action.data,
      };
    case frontConstants.GET_REMOVEITEM_FAILURE:
      return {
        ...state,
        sending: false,
        cartError: action.error,
      };
    case frontConstants.GET_CHECKOUT_REQUEST:
      return {
        ...state,
        paying: true,
      };
    case frontConstants.GET_CHECKOUT_SUCCESS:
      if (action.data.btnst == true) {
        return {
          ...state,
          paying: true,
          checkoutStatus: action,
        };
      } else {
        return {
          ...state,
          paying: false,
          checkoutStatus: action,
        };
      }

    case frontConstants.GET_CHECKOUT_FAILURE:
      return {
        ...state,
        paying: false,
        cartError: action.error,
      };
    case frontConstants.GET_APPLYPROMO_REQUEST:
      return {
        ...state,
        promoError: {},
        sending: true,
      };
    case frontConstants.GET_APPLYPROMO_SUCCESS:
      return {
        ...state,
        sending: false,
        promoError: {},
        promoStatus: action.data,
      };
    case frontConstants.GET_APPLYPROMO_FAILURE:
      return {
        ...state,
        sending: false,
        promoError: action.error,
      };
    case frontConstants.GET_REGISTER_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_REGISTER_SUCCESS:
      return {
        ...state,
        sending: false,
        regStatus: action,
      };
    case frontConstants.GET_REGISTER_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.LOGOUT_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.LOGOUT_SUCCESS:
      return {
        ...state,
        sending: false,
        logoutStatus: action.data,
      };
    case frontConstants.LOGOUT_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_VOUCHERLIST_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_VOUCHERLIST_SUCCESS:
      return {
        ...state,
        sending: false,
        voucherList: action.data,
      };
    case frontConstants.GET_VOUCHERLIST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_VOUCHERLISTARCHIVE_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_VOUCHERLISTARCHIVE_SUCCESS:
      return {
        ...state,
        sending: false,
        voucherListArchive: action.data,
      };
    case frontConstants.GET_VOUCHERLISTARCHIVE_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_ORDERLIST_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_ORDERLIST_SUCCESS:
      return {
        ...state,
        sending: false,
        orderList: action.data,
      };
    case frontConstants.GET_ORDERLIST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_CUSTOMER_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        sending: false,
        custDetail: action.data,
      };
    case frontConstants.GET_CUSTOMER_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        sending: false,
        profileStatus: action.data,
      };
    case frontConstants.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordStatus: action.data,
        sending: false,
      };
    case frontConstants.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false,
      };
    case frontConstants.PRINT_VOUCHER_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.PRINT_VOUCHER_SUCCESS:
      return {
        ...state,
        sending: false,
        voucherDetail: action.data,
      };
    case frontConstants.PRINT_VOUCHER_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
        voucherDetail: action,
      };
    case frontConstants.PRINT_AVOUCHER_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.PRINT_AVOUCHER_SUCCESS:
      return {
        ...state,
        sending: false,
        voucherarchiveDetail: action.data,
      };
    case frontConstants.PRINT_AVOUCHER_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
        voucherDetail: action,
      };
    case frontConstants.GET_CATDEAL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_CATDEAL_SUCCESS:
      return {
        ...state,
        sending: false,
        dealList: action.data,
      };
    case frontConstants.GET_CATDEAL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_STORECREDIT_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_STORECREDIT_SUCCESS:
      return {
        ...state,
        sending: false,
        creditAmount: action.data,
      };
    case frontConstants.GET_STORECREDIT_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_COUPON_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_COUPON_SUCCESS:
      return {
        ...state,
        sending: false,
        couponStatus: action.data,
      };
    case frontConstants.GET_COUPON_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_SETATTRIBUTE_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_SETATTRIBUTE_SUCCESS:
      return {
        ...state,
        sending: false,
        attribute: action.data,
      };
    case frontConstants.GET_SETATTRIBUTE_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.POST_SUBSCRIBE_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.POST_SUBSCRIBE_SUCCESS:
      return {
        ...state,
        sending: false,
        subscribeStatus: action.data,
      };
    case frontConstants.POST_SUBSCRIBE_FAILURE:
      return {
        ...state,
        sending: false,
        errorSubscriber: action.error,
      };
    case frontConstants.POST_AUTH_CITY_PWD_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.POST_AUTH_CITY_PWD_SUCCESS:
      return {
        ...state,
        sending: false,
        cityPasswordStatus: action.data,
      };
    case frontConstants.POST_AUTH_CITY_PWD_FAILURE:
      return {
        ...state,
        sending: false,
        errorCityPasswordStatus: action.error,
      };
    case frontConstants.CHECK_USER_DEAL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.CHECK_USER_DEAL_SUCCESS:
      return {
        ...state,
        sending: false,
        userdealResponse: action.data,
      };
    case frontConstants.CHECK_USER_DEAL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_CITY_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_CITY_SUCCESS:
      return {
        ...state,
        sending: false,
        cityList: action.data,
      };
    case frontConstants.GET_CITY_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_WIDGET_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_WIDGET_SUCCESS:
      return {
        ...state,
        sending: false,
        widgetImage: action.data,
      };
    case frontConstants.GET_WIDGET_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.POST_PARTNER_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.POST_PARTNER_SUCCESS:
      return {
        ...state,
        sending: false,
        partnerStatus: action.data,
      };
    case frontConstants.POST_PARTNER_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.PARTNER_PERMISSION_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.PARTNER_PERMISSION_SUCCESS:
      return {
        ...state,
        sending: false,
        becomePermission: action.data,
      };
    case frontConstants.PARTNER_PERMISSION_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.POST_STATUS_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.POST_STATUS_SUCCESS:
      return {
        ...state,
        sending: false,
        ordertracking: action.data,
      };
    case frontConstants.POST_STATUS_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.POST_CHARITYLIST_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.POST_CHARITYLIST_SUCCESS:
      return {
        ...state,
        sending: false,
        getCharity: action.data,
      };
    case frontConstants.POST_CHARITYLIST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.REMOVE_ROMO_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.REMOVE_ROMO_SUCCESS:
      return {
        ...state,
        sending: false,
        promoError: {},
        promoRemoveStatus: action.data,
      };
    case frontConstants.REMOVE_ROMO_FAILURE:
      return {
        ...state,
        sending: false,
        promoError: action.error,
      };
    case frontConstants.GET_COUPONLIST_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_COUPONLIST_SUCCESS:
      return {
        ...state,
        sending: false,
        couponList: action.data,
      };
    case frontConstants.GET_COUPONLIST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_REFFERALS_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_REFFERALS_SUCCESS:
      return {
        ...state,
        sending: false,
        refferals: action.data,
      };
    case frontConstants.GET_REFFERALS_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.DELETE_CARD_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.DELETE_CARD_SUCCESS:
      return {
        ...state,
        sending: false,
        card: action.data,
      };
    case frontConstants.DELETE_CARD_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_ALLCITY_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_ALLCITY_SUCCESS:
      return {
        ...state,
        sending: false,
        allCityList: action.data,
      };
    case frontConstants.GET_ALLCITY_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_LANGLIST_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_LANGLIST_SUCCESS:
      return {
        ...state,
        sending: false,
        langList: action.data,
      };
    case frontConstants.GET_LANGLIST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_MAILEDLIST_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_MAILEDLIST_SUCCESS:
      return {
        ...state,
        sending: false,
        mailedList: action.data,
      };
    case frontConstants.GET_MAILEDLIST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_GIFTLIST_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_GIFTLIST_SUCCESS:
      return {
        ...state,
        sending: false,
        giftList: action.data,
      };
    case frontConstants.GET_GIFTLIST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_GENERATEDLIST_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_GENERATEDLIST_SUCCESS:
      return {
        ...state,
        sending: false,
        generatedList: action.data,
      };
    case frontConstants.GET_GENERATEDLIST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_SUBSCRIBERDETAIL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_SUBSCRIBERDETAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        subscriberDetail: action.data,
      };
    case frontConstants.GET_SUBSCRIBERDETAIL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_TAX_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_TAX_SUCCESS:
      return {
        ...state,
        sending: false,
        taxRate: action.data,
      };
    case frontConstants.GET_TAX_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    case frontConstants.GET_SEARCHSTATE_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.GET_SEARCHSTATE_SUCCESS:
      return {
        ...state,
        sending: false,
        SearchStateList: action.data,
      };
    case frontConstants.GET_SEARCHSTATE_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };

    case frontConstants.CHECKGUESTEMAIL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.CHECKGUESTEMAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        GuestEmail: action.data,
      };
    case frontConstants.CHECKGUESTEMAIL_FAILURE:
      return {
        ...state,
        sending: false,
        GuestEmail: action.error,
      };
    case frontConstants.REGGUESTEMAIL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case frontConstants.REGGUESTEMAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        StatusGuestEmail: action.data,
      };
    case frontConstants.REGGUESTEMAIL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/frontReducer.js